import React from 'react'
import styles from '../../../CSS/main.css'
import { toast } from 'react-hot-toast'

const Toast = (text: string) => (): JSX.Element => {
  return (
    <div className={styles.UIMessage}>
      <span>{text}</span>
    </div>
  )
}

export const showToast = (text: string): void => {
  toast.custom(Toast(text), { duration: 700, position: 'bottom-center' })
}

export const showError = (text: string): void => {
  toast.error(text, { duration: 1500, position: 'top-center' })
}
